import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { FormProdutosComponent } from './form-produtos/form-produtos.component';
import { ProdutoService } from './produtos.service';
import { LoadingService } from '../../../util/loader.service';

@Component({
  selector: 'app-produtos',
  templateUrl: './produtos.component.html',
  styleUrls: ['./produtos.component.scss']
})
export class ProdutosComponent implements OnInit {
  public modalRef: BsModalRef;
  produtos = [];
  constructor(private modalService: BsModalService, private service: ProdutoService,public loader: LoadingService) {

    this.carregarProdutos();
  }

  ngOnInit() {
  }


  carregarProdutos() {
    this.service.consultarProduto().subscribe((itens) => {
      // this.loader.hide("body");
      //this.page.count = itens.count;
      this.produtos = itens;

      // this.botoesAtivados = true;
    });
  }

  openEditProduct(record){
    this.loader.show("body");
    this.service.detalharProduto(record.id_produto).subscribe((itens) => {
      this.loader.hide("body");
      const config: ModalOptions = {
        backdrop: 'static',
        keyboard: false,
        animated: true,
        class: 'modal-lg',
        // size: 'lg', // sm, md, lg
        ignoreBackdropClick: true,
        initialState: {
          record:itens
        }
      };
      this.modalRef = this.modalService.show(FormProdutosComponent, config);

      this.modalRef.content.onClose.subscribe(result => {

      });
    });
  }

  openNewProduct(event) {


    const config: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      animated: true,
      class: 'modal-lg',
      // size: 'lg', // sm, md, lg
      ignoreBackdropClick: true,
      initialState: {

      }
    };
    this.modalRef = this.modalService.show(FormProdutosComponent, config);

    this.modalRef.content.onClose.subscribe(result => {

    });

  }


}
